const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-12 px-6 md:px-12 lg:px-24 border-t border-border">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
        <p>© {currentYear} Allen Le Yaouanc</p>
        <div className="flex gap-8">
          <a 
            href="https://www.linkedin.com/in/allenleyaouanc/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="link-hover hover:text-foreground transition-colors duration-300"
          >
            LinkedIn
          </a>
          <a 
            href="https://www.behance.net/allenleyaouanc/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="link-hover hover:text-foreground transition-colors duration-300"
          >
            Behance
          </a>
          <a 
            href="https://github.com/TheYoungYankis/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="link-hover hover:text-foreground transition-colors duration-300"
          >
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
